export default {"src":"/_next/static/media/series_placeholder.5662e5a1.svg","height":102,"width":102,"blurWidth":0,"blurHeight":0};